<template>
  <div>
    <div>
      <!-- Main content area start here -->
      <section class="resultPage innerPage">
        <div class="container">
          <div class="breadcrumb">
            <!-- Breadcrumb NavXT 6.2.0 -->
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
            <span property="itemListElement" typeof="ListItem">
              <span property="name">搜索</span>
              <meta property="position" content="2">
            </span>
          </div>
          <!-- Page Title -->
          <h4>搜索</h4>
          <!-- Page Title -->
          <div class="showHideBtns">
            <div class="show btns active">显示高级搜索</div>
            <div class="hide btns">隐藏高级搜索</div>
          </div>
        </div>
        <form
          id="searchform"
          @submit="hreftwo"
        >
          <div id="advancedSearch" class="grayBg">
            <div class="container">
              <div class="lookingFor">
                <p>您可使用下拉列表精准地查找所需的酒款。</p>
                <p>您可以使用过滤器筛选结果，以显示您感兴趣的内容。</p>
                <p>
                  <!--

<h6>Can't find what you are looking for?</h6>

                  -->
                </p>
              </div>
              <div class="advancedSearchForm">
                <div class="form-control" style="overflow:auto">
                  <input
                    style="width:100%"
                    id="keyword"
                    name="search"
                    placeholder="酒庄名/葡萄园名原文"
                    type="search"
                    autocomplete="off"
                  >
                </div>

                <div>
                  <h6>高级搜索</h6>
                </div>

                <div class="advField">
                  <!-- Vintage start -->
                  <div class="form-control">
                    <select class="wide" name="vintage" id="vintage" style="display: none;"></select>
                  </div>
                  <!-- Vintage start -->

                  <!-- Producer start -->
                  <div class="form-control">
                    <select class="wide" name="producer" id="producer" style="display: none;"></select>
                  </div>
                  <!-- Producer end -->

                  <!-- Vineyard start -->
                  <div class="form-control">
                    <select class="wide" name="vineyard" id="vineyard" style="display: none;"></select>
                  </div>
                  <!-- Vineyard end -->
                </div>

                <div class="advField last">
                  <!-- Village start -->
                  <div class="form-control">
                    <select class="wide" name="village" id="village" style="display: none;"></select>
                  </div>
                  <!-- Village end -->
                  <!-- Colours end -->
                </div>

                <div class="advFieldBtn">
                  <a href="#/insideburgundy" class="reset">清空结果</a>
                </div>
                <div class="advFieldBtn last searchBtns">
                  <input
                    value="查  询"
                    id="searchsubmit"
                    type="button"
                    @click="hreftwo"
                    class="btn fluid"
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="filter-results">
              <h4>筛选</h4>
              <div>
                <select class="wide" id="relatedType"></select>
              </div>
            </div>
          </div>
        </form>
        <div class="container">
          <div class="resultList" v-if="page.total>0">
            <ul>
              <template v-for="item in datalist">
                <h2 class="resultHeading"   v-if="item.list.length">{{item.name}}</h2>
                <li v-for="(it,index) in item.list" :key="index">
                  <div class="five_star_listing" v-if="it.starRating==5&&it.relatedType=='酒评'">
                    <div class="jasperStarWine">
                      <span class="five_star_icon">
                        <font style="vertical-align: inherit;">
                          <font style="vertical-align: inherit;">5</font>
                        </font>
                      </span>
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">5 Star Wine</font>
                      </font>
                      <a href="#/Fivestars" class="five_star_link">
                        <font style="vertical-align: inherit;">
                          <font style="vertical-align: inherit;">查看五星品鉴笔记</font>
                        </font>
                      </a>
                    </div>
                    <div class="noteContent">
                      <div class="noteTitle">
                        <span>
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">{{it.title}}</font>
                          </font>
                        </span>
                        <div class="rightRating">
                          <div class="star-ratings-sprite">
                            <span style="width:100%" class="star-ratings-sprite-rating"></span>
                          </div>
                          <span class="score">
                            <font style="vertical-align: inherit;">
                              <font style="vertical-align: inherit;">{{it.score}}</font>
                            </font>
                          </span>
                        </div>
                      </div>
                      <div class="noteText">{{it.introduction}}</div>
                      <div class="fullinfo">
                        <a :href="'#/tastingnotes?id='+it.relatedId">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">完整信息</font>
                          </font>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div class="noteContent">
                      <div class="noteTitle" :id="it.relatedId">
                        <span>{{it.title}}</span>
                        <div class="rightRating" v-if="it.relatedType=='品鉴报告'">
                          <div class="star-ratings-sprite">
                            <!-- <span style="width:60%" class="star-ratings-sprite-rating"></span> -->
                            <!-- <span style="width:60%" class="star-ratings-sprite-ratinga"></span> -->
                          </div>
                          <span class="score">{{it.createTime}}</span>
                        </div>

                        <div class="rightRating" v-if="it.relatedType=='资讯'">
                          <div class="star-ratings-sprite">
                            <!-- <span style="width:60%" class="star-ratings-sprite-rating"></span> -->
                            <span style="width:60%"></span>
                          </div>
                          <span class="score">{{it.createTime}}</span>
                        </div>

                        <div class="rightRating" v-if="it.relatedType=='酒评'">
                          <div class="star-ratings-sprite">
                            <!-- <span style="width:60%" class="star-ratings-sprite-rating"></span> -->
                            <img
                              src="https://image.insideburgundy.cn/redstar.png"
                              v-if="it.starRating>0"
                            >
                            <img
                              src="https://image.insideburgundy.cn/redstar.png"
                              v-if="it.starRating>1"
                            >
                            <img
                              src="https://image.insideburgundy.cn/redstar.png"
                              v-if="it.starRating>2"
                            >
                            <img
                              src="https://image.insideburgundy.cn/redstar.png"
                              v-if="it.starRating>3"
                            >
                            <img
                              src="https://image.insideburgundy.cn/redstar.png"
                              v-if="it.starRating>4"
                            >
                            <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                            <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                            <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                            <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                            <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                          </div>
                          <span class="score">{{it.score}}</span>
                        </div>
                      </div>
                      <div class="noteText">{{it.introduction}}</div>
                      <div class="fullinfo">
                        <a :href="seturl(it.relatedType,it.relatedId)">详细信息</a>
                      </div>
                    </div>
                  </div>
                </li>
              </template>
            </ul>

            <div v-if="!this.$store.state.isLogin||this.$store.state.userdata.level=='普通会员'">
              <section style="margin-top:20px;position:relative">
                <h2 class="resultHeading">查看更多内容</h2>
                <div class="noteContent" style="margin-top:30px;">
                  <div class="noteTitle">
                    <span>2002, Ruchottes-Chambertin Grand Cru, Christophe Roumier</span>
                    <div class="rightRating">
                      <div class="star-ratings-sprite">
                        <img src="https://image.insideburgundy.cn/redstar.png">
                        <img src="https://image.insideburgundy.cn/redstar.png">
                        <img src="https://image.insideburgundy.cn/redstar.png">
                        <img src="https://image.insideburgundy.cn/redstar.png">
                        <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                        <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                        <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                        <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                        <img src="https://image.insideburgundy.cn/whitestar.png" alt>
                      </div>
                      <span class="score">95</span>
                    </div>
                  </div>
                  <div
                    class="noteText"
                  >颜色不超过中等深度，香气显得有些内敛， 但仍然透露出很多细节。这是一款活泼、细腻的葡萄酒，带有清爽的酸度。 今天它的表现和Rousseau的 Clos St Jacques以及Mugneret-Gibourg的Ruchottes-Chambertin有很多共同之处。</div>
                </div>
                <div class="contentmask"></div>
              </section>
              <div class="whySubscribe" style="padding-top: 20px">
                <div class="whySubscribeText animate fadeInUp triggeredCSS3" style="width: 100%">
                  <a href="#/Subscribe" style="text-decoration:none;">
                    <h1>为什么订阅Inside Burgundy</h1>
                  </a>
                  <ul>
                    <li>通过订阅您将获得所有的品鉴报告及过往酒评</li>
                    <li>您可通过网页、微信小程序、App（开发中）全平台查看酒评，方便快捷</li>
                    <li>做为订阅用户，您将获赠Inside Burgundy的定制版Riedel勃艮第酒杯一支</li>
                    <li>订阅费用为800元/年</li>
                  </ul>
                  <a href="#/Subscribe" target class="btn white">立即订阅</a>
                </div>
              </div>
            </div>

            <div class="tablenav-pages" v-if="paignation.length>1">
              <div class="pagination">
                <a class="prev" @click="pagechange">Previous Page</a>
                <template v-for="(item,index) in paignation">
                  <span class="current" v-if="item.active" :key="index">{{item.name}}</span>
                  <a @click="pagechange" v-else :key="index">{{item.name}}</a>
                </template>
                <a class="next" @click="pagechange">Next Page</a>
              </div>
            </div>
          </div>

          <div class="resultList" v-else>
            <div class="noResult">
              <h2>未找到内容</h2>
              <p>
                抱歉，没找到与
                <b>"{{keyword}}"</b>相匹配的内容
                <br>您可尝试使用其他关键字搜索
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ajax from "../ajax";

export default {
  data() {
    return {
      keyword: "",
      datalist: [],
      filterType: ["全部", "品鉴报告", "资讯"],
      page: {
        total: 0,
        pageNo: 0
      }
    };
  },
  mounted() {
    this.getselectdata();
    this.setselectdata();
    let _this = this;
    $("#relatedType").on("change", () => {
      _this.page.pageNo = 0;
      this.hreftwo();
    });

    $(".show").click(function() {
      $(".hide").removeClass("active");
      $(this).addClass("active");
      $("#advancedSearch").slideDown(500);
    });

    $(".hide").click(function() {
      $(".show").removeClass("active");
      $(this).addClass("active");
      $("#advancedSearch").slideUp(500);
    });
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    }
  },
  computed: {
    paignation() {
      let page = [];
      let total = Math.ceil(this.page.total / 10);
      // let total = 9;
      let pageNo = this.page.pageNo + 1;
      if (total > 7) {
        let left = [];
        if (pageNo < 5) {
          left = [1, 2, 3, 4, 5, 6, "…", total];
        } else if (pageNo > total - 4) {
          left = [1, "…", total - 4, total - 3, total - 2, total - 1, total];
        } else {
          left = [
            1,
            "…",
            pageNo - 2,
            pageNo - 1,
            pageNo,
            pageNo + 1,
            pageNo + 2,
            "…",
            total
          ];
        }
        left.forEach(item => {
          page.push({ name: item, active: item === pageNo || item == "…" });
        });
      } else {
        for (let a = 0; a < total; a++) {
          page.push({ name: a + 1, active: a === this.page.pageNo });
        }
      }

      return page;
    }
  },
  methods: {
    pageset7() {
      let _this = this;
      let ar = {
        name: (function() {
          if (
            _this.page.pageNo + 3 > 7 &&
            _this.page.pageNo + 4 == Math.ceil(_this.page.total / 10)
          ) {
            return _this.page.pageNo + 3;
          }
          if (
            _this.page.pageNo + 3 > 7 &&
            _this.page.pageNo + 4 < Math.ceil(_this.page.total / 10)
          ) {
            return "…";
          }
        })(),
        active: (function() {
          if (
            _this.page.pageNo + 3 > 7 &&
            _this.page.pageNo + 4 == Math.ceil(_this.page.total / 10)
          ) {
            if (_this.page.pageNo + 3 == _this.page.pageNo) {
              return true;
            } else {
              return false;
            }
          }
          if (
            _this.page.pageNo + 3 > 7 &&
            _this.page.pageNo + 4 < Math.ceil(_this.page.total / 10)
          ) {
            return true;
          }
        })()
      };
    },
    seturl(name, id) {
      let url = "";
      switch (name) {
        case "品鉴报告":
          url = "#/Qualification?id=" + id;
          break;
        case "资讯":
          url = "#/Latestinformation?id=" + id;
          break;
        case "酒评":
          url = "#/tastingnotes?id=" + id;
          break;
        case "五星":
          url = "#/Fivestars";
          break;
      }
      return url;
    },
    setselectdata() {
      let keyword = this.$route.query.keyword;
      if (keyword) {
        window.SearchQuery = { keyword };
      }
      if (window.SearchQuery) {
        $("#keyword").val(window.SearchQuery.keyword);
      }
      this.showList(window.SearchQuery || {});
      $("select").niceSelect();
    },
    pagechange(e) {
      let n = e.target.innerText;
      if (n == "Previous Page") {
        if (this.page.pageNo > 0) this.page.pageNo--;
        else return false;
      } else if (n == "Next Page") {
        if (this.page.pageNo < this.paignation.length - 1) this.page.pageNo++;
        else return false;
      } else {
        this.page.pageNo = Number(n) - 1;
      }
      this.showList(this.page.query);
    },
    getselectdata() {
      ajax.getvintage().then(res => {
        this.showhtml("vintage", res.data);
      });
      ajax.getproducer().then(res => {
        this.showhtml("producer", res.data);
      });
      ajax.getvillage().then(res => {
        this.showhtml("village", res.data);
      });
      ajax.getvineyard().then(res => {
        this.showhtml("vineyard", res.data);
      });
      ajax.getfilters().then(res => {
        this.filterType = res.data;
        this.showhtml("relatedType", res.data);
        this.filterType.shift();
      });
    },
    getquery() {
      let list = [
        "keyword",
        "vintage",
        "producer",
        "village",
        "vineyard",
        "relatedType"
      ];
      let query = {};
      list.forEach(item => {
        query[item] = $(`#${item}`).val();
      });
      return query;
    },
    showhtml(id, data) {
      let arr = data.map(item => {
        if (window.SearchQuery && item == window.SearchQuery[id])
          return `<option value="${item}" selected="selected">${item}</option>`;
        else return `<option value="${item}">${item}</option>`;
      });
      $(`#${id}`)
        .html(arr.join(""))
        .niceSelect("update");
    },
    hreftwo(e) {
      e.preventDefault();
      
      let query = this.getquery();
      this.showList(query);

      return false
    },
    showList(query) {
      this.keyword = query.keyword;
      this.page.query = query;
      query.pageNo = this.page.pageNo;
      ajax.getsearch(query).then(res => {
        //  this.showlist = res.data.data;
        let list = [];
        this.filterType.forEach(item => {
          let ar = res.data.data.filter(it => it.relatedType == item);
          list.push({
            name: item,
            list: ar
          });
        });
        this.datalist = list;
        this.page.total = res.data.total;
        window.scrollTo(0, 600);
      });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Insideburgundy.vue